// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import { combineReducers } from 'redux';
import { ActionTypes } from 'utils/constants.jsx';
import { SMSTypes } from 'mattermost-redux/action_types';

function searchMode(state = false, action) {
    switch (action.type) {
        case ActionTypes.SET_SMS_SEARCH_MODE:
            return action.state;
        default:
            return state;
    }
}

function selectedMessageId(state = '', action) {
    switch (action.type) {
        case ActionTypes.SET_SELECTED_MESSAGE_ID:
            return action.state;
        default:
            return state;
    }
}

function searchTerms(state = '', action) {
    switch (action.type) {
        case ActionTypes.UPDATE_SMS_SEARCH_TERMS:
            return action.terms;
        default:
            return state;
    }
}

function channelFindTerms(state = '', action) {
    switch (action.type) {
        case ActionTypes.UPDATE_SMS_FIND_CHANNEL_TERMS:
            return action.terms;
        case SMSTypes.PREPEND_SMS_CHANNEL_LIST:
            return "";
        default:
            return state;
    }
}

function searchChannel(state = '', action) {
    switch (action.type) {
        case ActionTypes.UPDATE_SMS_SEARCH_CHANNEL:
            return action.channel_id;
        default:
            return state;
    }
}

function displayPopupSearchResults(state = false, action) {
    switch (action.type) {
        case ActionTypes.DISPALY_POPUP_SEARCH_RESULTS:
            return action.data;
        default:
            return state;
    }
}

function isSearchingTerm(state = false, action) {
    switch (action.type) {
        case SMSTypes.GET_SMSES_SEARCH_REQUEST:
            return true;
        case SMSTypes.GET_SMSES_SEARCH_FAILURE:
        case SMSTypes.GET_SMSES_SEARCH_SUCCESS:
            return false;
        default:
            return state;
    }
}

function searchResultScrollHeight(state = 0, action) {
    switch (action.type) {
        case ActionTypes.SET_SMS_SEARCH_RESULT_SCROLL_HEIGHT:
            return action.data;
        case SMSTypes.CLEAR_SEARCH_SMSES:
            return 0
        default:
            return state;
    }
}

export default combineReducers({
    searchMode,
    selectedMessageId,
    searchTerms,
    searchChannel,
    displayPopupSearchResults,
    isSearchingTerm,
    searchResultScrollHeight,
    channelFindTerms,
});
